/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */

export type GlobalEntityListFunctionalType = typeof GlobalEntityListFunctionalType[keyof typeof GlobalEntityListFunctionalType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GlobalEntityListFunctionalType = {
  aggregator: 'aggregator',
  alternative_investment_vehicle: 'alternative_investment_vehicle',
  blocker: 'blocker',
  coinvestment_vehicle: 'coinvestment_vehicle',
  feeder_fund: 'feeder_fund',
  general_partner: 'general_partner',
  general_partner_and_special_limited_partner: 'general_partner_and_special_limited_partner',
  holding_company: 'holding_company',
  investment: 'investment',
  investment_property: 'investment_property',
  investor: 'investor',
  joint_venture: 'joint_venture',
  lender: 'lender',
  main_fund: 'main_fund',
  management_company: 'management_company',
  master_fund: 'master_fund',
  parallel_fund: 'parallel_fund',
  phantom_aggregator: 'phantom_aggregator',
  special_limited_partner: 'special_limited_partner',
  unmanaged: 'unmanaged',
} as const;
